// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"styles_modalDialog__2Sbe5"};